import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import Image from 'next/legacy/image';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { textBase } from '@yoweb/ui/components/typography';
import { th } from '@yoweb/ui/styles/utils/theme';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { textAlignMixin } from '@yoweb/ui/styles/utils/mixins.utils';
import { LoadingPage } from '@yoweb/ui/components/LoadingPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FlyoutLayout = styled.div.withConfig({
  componentId: "sc-18vp3f3-0"
})(["width:100%;background-color:", ";display:grid;grid-template-rows:auto 1fr;height:100%;position:absolute;"], function (_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'sandLight' : _ref$backgroundColor;
  return th.getColor(backgroundColor);
});
export var FlyoutTitle = styled(motion.h3).withConfig({
  componentId: "sc-18vp3f3-1"
})(["", ";font-weight:", ";display:inline-block;"], textBase, th.getFontWeight('bold'));
export var FlyoutHeader = styled.div.withConfig({
  componentId: "sc-18vp3f3-2"
})(["position:relative;display:grid;background-color:", ";padding:", " ", " ", " ", ";transition:padding-top ", "ms linear;z-index:1;", " ", ""], function (_ref2) {
  var _ref2$backgroundColor = _ref2.backgroundColor,
      backgroundColor = _ref2$backgroundColor === void 0 ? 'gingko' : _ref2$backgroundColor;
  return th.getColor(backgroundColor);
}, th.getSpace('medium3'), th.getSpace('normal3'), function (_ref3) {
  var _ref3$pb = _ref3.pb,
      pb = _ref3$pb === void 0 ? 'normal3' : _ref3$pb;
  return th.getSpace(pb);
}, th.getSpace('normal3'), th.getDuration('interaction'), function (_ref4) {
  var $isCompact = _ref4.$isCompact;
  return $isCompact && css(["padding-top:", ";"], th.getSpace('normal3'));
}, function (_ref5) {
  var $showBoxShadow = _ref5.$showBoxShadow;
  return $showBoxShadow && css(["box-shadow:", ";"], th.getShadow('secondary'));
});
export var FlyoutStepHeader = styled(FlyoutHeader).withConfig({
  componentId: "sc-18vp3f3-3"
})(["&&{padding:", " ", " ", ";text-align:center;grid-gap:", ";", " ", "}"], th.getSpace('normal4'), th.getSpace('normal3'), th.getSpace('normal2'), th.getSpace('normal2'), function (_ref6) {
  var _ref6$$pt = _ref6.$pt,
      $pt = _ref6$$pt === void 0 ? 'medium3' : _ref6$$pt;
  return $pt && css(["padding-top:", ";"], th.getSpace($pt));
}, media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      grid-gap: ", ";\n    "])), th.getSpace('normal1')));
export var FlyoutHeroHeader = function FlyoutHeroHeader(_ref7) {
  var heroImage = _ref7.heroImage,
      children = _ref7.children,
      isCompact = _ref7.isCompact;
  return /*#__PURE__*/_jsxs(FlyoutHeroHeaderContainer, {
    $isCompact: isCompact,
    "data-testid": "flyout-hero-header",
    children: [!heroImage && /*#__PURE__*/_jsx(LoadingPage, {}), heroImage && /*#__PURE__*/_jsx(Image, {
      src: heroImage,
      objectFit: "cover",
      layout: "fill"
    }), children]
  });
};
export var FlyoutProductDescriptionHeader = function FlyoutProductDescriptionHeader(_ref8) {
  var heroImage = _ref8.heroImage,
      children = _ref8.children,
      isCompact = _ref8.isCompact;
  return /*#__PURE__*/_jsxs(FlyoutProductDescriptionHeaderContainer, {
    $isCompact: isCompact,
    "data-testid": "flyout-hero-header",
    children: [!heroImage && /*#__PURE__*/_jsx(LoadingPage, {}), heroImage && !isCompact && /*#__PURE__*/_jsx(Image, {
      src: heroImage,
      objectFit: "cover",
      layout: "fill"
    }), children]
  });
};
export var HeaderContainer = styled.div.withConfig({
  componentId: "sc-18vp3f3-4"
})(["transform:translateX(0);transition:transform ", "ms linear;", " ", ";"], th.getDuration('interaction'), function (_ref9) {
  var $isCompact = _ref9.$isCompact;
  return $isCompact && css(["transform:translateX(50%);"]);
}, textAlignMixin);
export var Content = styled.div.withConfig({
  componentId: "sc-18vp3f3-5"
})(["position:absolute;inset:0;padding:", ";padding-top:", ";", " overflow-y:auto;background-color:", ";"], function (_ref10) {
  var $padding = _ref10.$padding;
  return th.getSpace($padding !== null && $padding !== void 0 ? $padding : 'normal2');
}, function (_ref11) {
  var $paddingTop = _ref11.$paddingTop;
  return $paddingTop && th.getSpace($paddingTop);
}, media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", ";\n    padding-top: ", ";\n  "])), function (_ref12) {
  var $padding = _ref12.$padding;
  return th.getSpace($padding !== null && $padding !== void 0 ? $padding : 'normal3');
}, function (_ref13) {
  var $paddingTop = _ref13.$paddingTop;
  return $paddingTop && th.getSpace($paddingTop);
}), function (_ref14) {
  var bgColor = _ref14.bgColor;
  return bgColor && th.getColor(bgColor);
});
export var FlyoutButtonPanelWrapper = styled.div.withConfig({
  componentId: "sc-18vp3f3-6"
})(["display:flex;border-top:1px solid ", ";flex-direction:column;background-color:", ";position:sticky;bottom:-", ";z-index:", ";padding:", ";row-gap:", ";margin:", " -", " -", " -", ";"], th.getColor('base100'), function (_ref15) {
  var bgColor = _ref15.bgColor;
  return bgColor ? th.getColor(bgColor) : th.getColor('base000');
}, th.getSpace('normal3'), th.getZIndex('layer'), th.getSpace('normal2'), th.getSpace('normal1'), th.getSpace('small3'), th.getSpace('normal3'), th.getSpace('normal3'), th.getSpace('normal3'));
export var FlyoutButtonPanel = styled.div.withConfig({
  componentId: "sc-18vp3f3-7"
})(["display:flex;flex-direction:column;row-gap:", ";", ""], th.getSpace('small4'), media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    column-gap: ", ";\n    flex-direction: row;\n    justify-content: flex-start;\n  "])), th.getSpace('small4')));
export var FlyoutButton = styled(Button).withConfig({
  componentId: "sc-18vp3f3-8"
})(["", ""], media.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    flex: 1;\n  "]))));
var FlyoutHeroHeaderContainer = styled.div.withConfig({
  componentId: "sc-18vp3f3-9"
})(["position:relative;width:100%;max-width:100vw;height:375px;transition:height ", "ms ease-in-out;", " ", ""], th.getDuration('fast'), function (_ref16) {
  var $isCompact = _ref16.$isCompact;
  return $isCompact && css(["height:200px;"]);
}, media.sm(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: 563px;\n    ", "\n  "])), function (_ref17) {
  var $isCompact = _ref17.$isCompact;
  return $isCompact && css(["height:210px;"]);
}));
var FlyoutProductDescriptionHeaderContainer = styled.div.withConfig({
  componentId: "sc-18vp3f3-10"
})(["position:relative;width:100%;max-width:100vw;height:", ";transition:height ", "ms ease-in-out;background-color:", ";", " ", ""], pxToRem(281), th.getDuration('fast'), th.getColor('base000'), function (_ref18) {
  var $isCompact = _ref18.$isCompact;
  return $isCompact && css(["height:", ";border-bottom:1px solid ", ";"], pxToRem(72), th.getColor('base100'));
}, media.sm(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    height: ", ";\n    width: ", ";\n\n    ", "\n  "])), pxToRem(375), pxToRem(563), function (_ref19) {
  var $isCompact = _ref19.$isCompact;
  return $isCompact && css(["height:", ";"], pxToRem(88));
}));